export function isRtl(lang: string): { isRtl: boolean; direction: 'rtl' | 'ltr' } {
  const rtl = lang === 'ar';
  return { isRtl: rtl, direction: rtl ? 'rtl' : 'ltr' };
}
